import { useQuery } from '@tanstack/react-query';

import { TimeConstants } from '../../../constants/time';
import { PromotionEventApi } from '../promotion-event.api';

/** GNB 활성 기획전 목록 조회 훅 */
export const usePromotionEventGnbQuery = () => {
  return useQuery({
    queryKey: PromotionEventApi.queryKeys.findGnb(),
    queryFn: PromotionEventApi.findGnb,
    staleTime: TimeConstants.FIVE_MINUTES,
  });
};
